import { FOOTER_LINK } from './actionTypes';
import { TEAM_PAGE } from 'modules/team/actionTypes';
import { TeamMapper } from 'mappers/team';
import { get } from 'lodash';
const getFooterLinkData = () => (dispatch, getState, { api }) => {
  dispatch({
    type: FOOTER_LINK.FOOTER_LINK_REQUEST,
    payload: {},
    test: api
      .post(`getFooterLinks.json`)
      .then(res => {
        const response = get(res, 'data.data.footerLinks', {});
        dispatch({
          type: FOOTER_LINK.FOOTER_LINK_SUCCESS,
          payload: response,
        });
        return res.data;
      })
      .catch(error => {
        dispatch({
          type: FOOTER_LINK.FOOTER_LINK_FAILURE,
          error,
        });
      }),
  });
};

export const FooterActions = {
  getFooterLinkData,
};
